import {NgModule} from "@angular/core";
import {DeploymentsComponent} from "./deployments.component";
import {CommonModule} from "@angular/common";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatBadgeModule} from "@angular/material/badge";
import {MatChipsModule} from "@angular/material/chips";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatSelectModule} from "@angular/material/select";
import {OrderByModule} from "@app/pipes/order-by/order-by.module";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {TimeLimiterModule} from "@app/pages/deployments/pipes/time-limiter/time-limiter.module";


@NgModule({
    declarations: [DeploymentsComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    FormsModule,
    MatBadgeModule,
    MatChipsModule,
    MatButtonToggleModule,
    MatSelectModule,
    OrderByModule,
    MatCheckboxModule,
    TimeLimiterModule

  ]
})
export class DeploymentsModule {
}

